import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormClientComponent } from './form-client/form-client.component';
import { ExternalRedirectGuard } from './guards/external-redirect.guard';

const routes: Routes = [
  {
    path:'dashboard',
    loadChildren:()=>import('./dashboard/dashboard.module').then(m=>m.DashboardModule)
  },
  {
    path:'',
    loadChildren:()=>import('./auth/auth.module').then(m=>m.AuthModule)
  },
  {
    path:'benchmarking',
    loadChildren:()=>import('./benchmarking/benchmarking.module').then(m=>m.BenchmarkingModule)
  },
  {
    path:'comercial',
    loadChildren:()=>import('./comercial/comercial.module').then(m=>m.ComercialModule)
  },
  {
    path:'asamblea',
    loadChildren:()=>import('./assembly/assembly.module').then(m=>m.AssemblyModule)
  },
  {
    path:'ruleta',
    loadChildren:()=>import('./roulette/roulette.module').then(m=>m.RouletteModule)
  },
  {
    path:'fpqrs',
    loadChildren:()=>import('./viewfpqrs/viewfpqrs.module').then(m=>m.ViewfpqrsModule)
  },
  {
    path: 'form-client',
    component: FormClientComponent
  },
  {
    path: 'cuponera',
    loadChildren: () => import('./cuponera-publica/cuponera-publica.module').then(m => m.CuponeraPublicaModule)
  },
  {
    path: 'buscar-cliente',
    loadChildren: () => import('./buscar-cliente/buscar-cliente.module').then(m => m.BuscarClienteModule)
  },
  {
    path: 'desuscribir',
    loadChildren: () => import('./desuscribir/desuscribir.module').then(m => m.DesuscribirModule)
  },
  {
    path: 'portal-solicitudes',
    loadChildren: () => import('./portal-solicitudes/portal-solicitudes.module').then(m => m.PortalSolicitudesModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
